import { Spinner } from '@/ui-kit'
import { formValuesToUserProfile, useProfile, useUpdateProfile, userProfileToFormValues } from './api/profile'
import type { ProfileDetailsFormValues } from './ProfileDetailsForm'
import { ProfileDetailsForm } from './ProfileDetailsForm'
import { toast } from 'sonner'

export const ProfileInfo = () => {
  const { data: profile, isLoading } = useProfile()
  const { mutateAsync: updateProfile, isPending: isSubmittingProfile } = useUpdateProfile()

  const handleSubmit = async (data: ProfileDetailsFormValues) => {
    try {
      await updateProfile(formValuesToUserProfile(data))
      toast.success('Profile updated successfully')
    } catch (error) {
      console.error(error)
      toast.error('Failed to update profile')
    }

  }

  return !profile && isLoading ? (
    <div className="flex justify-center py-12">
      <Spinner />
    </div>
  ) : (
    <div className="max-w-[900px]">
      <ProfileDetailsForm
        submitButtonText="Save"
        onSubmit={handleSubmit}
        isSubmittingProfile={isSubmittingProfile}
        defaultValues={profile ? userProfileToFormValues(profile) : undefined}
      />
    </div>
  )
}
